/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Contact_Form_Sent_BodyInputs */

const en_contact_form_sent_body = /** @type {(inputs: Contact_Form_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We will answer at ${i?.email}, usually within one working day.`)
};

const pl_contact_form_sent_body = /** @type {(inputs: Contact_Form_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odpowiemy na ${i?.email}, zwykle w ciągu jednego dnia roboczego.`)
};

/**
* | output |
* | --- |
* | "We will answer at {email}, usually within one working day." |
*
* @param {Contact_Form_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_sent_body = /** @type {((inputs: Contact_Form_Sent_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Sent_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_sent_body(inputs)
	return en_contact_form_sent_body(inputs)
});